<template>
  <div class="comparator__card__panel">
    <img class="comparator__card__panel__img" :src="imageSrc">
    <p class="comparator__card__panel__text">
      {{ $t('home.comparator.noOffers') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'noOffers',
  data() {
    return {
      imageSrc: 'https://cdn.nextories.com/static/img/ccm_devis.png',
    };
  },
};
</script>
